import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';

const adminImpersonationActions = createActionCreators<
	{ T: 'ADMIN_IMPERSONATE_USER_START', P: { ownerId: string } },
	{ T: 'ADMIN_IMPERSONATE_USER_END'}
	>('ADMIN_IMPERSONATE_USER_START', 'ADMIN_IMPERSONATE_USER_END');

export const impersonateUser = (ownerId: string) => adminImpersonationActions.ADMIN_IMPERSONATE_USER_START({ ownerId });
export const stopImpersonatingUser = () => adminImpersonationActions.ADMIN_IMPERSONATE_USER_END();

type UserActions = ActionValues<typeof adminImpersonationActions>;
type UserActionTypes = ActionTypeNames<UserActions>;
export type Actions = UserActions[keyof UserActions];
export const ActionTypes = Object.keys(adminImpersonationActions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as UserActionTypes);
